import { Permission, useCurrentUser, usePermission } from '@bonusly/who-am-i';

import { useAwards } from '../../../api/hooks/awards';
import { AwardType } from '../../../api/hooks/enums';

export const useGiveableAwards = () => {
	const user = useCurrentUser();
	const canAccessAwards = usePermission(Permission.CanAccessAwards);

	const { data: awards, isLoading } = useAwards(
		{
			params: {
				type: AwardType.Manual,
				givable_by_user: user.id,
			},
		},
		{
			enabled: canAccessAwards,
			select: (data) => data.data.result.items,
		}
	);

	return {
		awards: canAccessAwards ? awards || [] : [],
		isLoading: canAccessAwards ? isLoading : false,
	};
};
